module.exports = __webpack_public_path__ + "icon-warning-lemon.22d099cb0072b736fdc4.svg";